module.exports = __webpack_public_path__ + "static/media/aplicacao.f5a6f0fc.png";